import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { dibsLazyClient } from 'dibs-lazy/exports/dibsLazyClient.ts';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense.tsx';

import { type PdpRespSharedPrintDetailsLazy_item$key } from './__generated__/PdpRespSharedPrintDetailsLazy_item.graphql.ts';
import { type PdpRespSharedPrintDetailsLazy_user$key } from './__generated__/PdpRespSharedPrintDetailsLazy_user.graphql.ts';

const PdpRespSharedPrintDetails = dibsLazyClient(
    () =>
        import(
            /* webpackChunkName: "PdpRespSharedPrintDetails" */ './PdpRespSharedPrintDetails.tsx'
        )
);

type Props = {
    item: PdpRespSharedPrintDetailsLazy_item$key;
    user: PdpRespSharedPrintDetailsLazy_user$key | null | undefined;
    currency: string;
    selectedSkuId?: string | null;
};

const itemFragment = graphql`
    fragment PdpRespSharedPrintDetailsLazy_item on Item {
        ...PdpRespSharedPrintDetails_item
    }
`;

const userFragment = graphql`
    fragment PdpRespSharedPrintDetailsLazy_user on User {
        ...PdpRespSharedPrintDetails_user
    }
`;

export const PdpRespSharedPrintDetailsLazy: FC<Props> = ({
    item: itemRef,
    user: userRef,
    currency,
    selectedSkuId,
}) => {
    const item = useFragment(itemFragment, itemRef);
    const user = useFragment(userFragment, userRef);
    return (
        <ClientSuspense fallback={null}>
            <PdpRespSharedPrintDetails
                item={item}
                user={user}
                currency={currency}
                selectedSkuId={selectedSkuId}
            />
        </ClientSuspense>
    );
};
